/** 申请类型 */
export const APPLY_TYPE = {
  /** 广州4050社保补贴 */
  GZ4050SBBT: 1,
  /** 适岗培训补贴 */
  SGPXBT: 2,
  /** 失业保险稳岗补贴 */
  SYBXWGBT: 3,
  /** 专业技术资格认定 */
  ZYJSZGRD: 4,
  /** 专业技术资格评审 */
  ZYJSZGPS: 5,
  /** 专业技术资格确认 */
  ZYJSZGQR: 6,
}
export const APPLY_TYPE_TEXT = {
  [APPLY_TYPE.GZ4050SBBT]: "广州4050社保补贴",
  [APPLY_TYPE.SGPXBT]: "适岗培训补贴",
  [APPLY_TYPE.SYBXWGBT]: "失业保险稳岗补贴",
  [APPLY_TYPE.ZYJSZGRD]: "专业技术资格认定",
  [APPLY_TYPE.ZYJSZGPS]: "专业技术资格评审",
  [APPLY_TYPE.ZYJSZGQR]: "专业技术资格确认",
}

/** 企业注册地 */
export const COMPANY_REGISTRATION_TEXT = {
  1: "天河",
  2: "越秀",
  3: "海珠",
  4: "白云",
  5: "荔湾",
  6: "黄埔",
  7: "番禺",
  8: "花都",
  9: "南沙",
  10: "从化",
  11: "增城",
}
/** 企业注册地选项 */
export const COMPANY_REGISTRATION_SELECTS = [
  {
    label: COMPANY_REGISTRATION_TEXT[1],
    value: 1,
  },
  {
    label: COMPANY_REGISTRATION_TEXT[2],
    value: 2,
  },
  {
    label: COMPANY_REGISTRATION_TEXT[3],
    value: 3,
  },
  {
    label: COMPANY_REGISTRATION_TEXT[4],
    value: 4,
  },
  {
    label: COMPANY_REGISTRATION_TEXT[5],
    value: 5,
  },
  {
    label: COMPANY_REGISTRATION_TEXT[6],
    value: 6,
  },
  {
    label: COMPANY_REGISTRATION_TEXT[7],
    value: 7,
  },
  {
    label: COMPANY_REGISTRATION_TEXT[8],
    value: 8,
  },
  {
    label: COMPANY_REGISTRATION_TEXT[9],
    value: 9,
  },
  {
    label: COMPANY_REGISTRATION_TEXT[10],
    value: 10,
  },
  {
    label: COMPANY_REGISTRATION_TEXT[11],
    value: 11,
  },
]

/** 户口性质 */
export const ACCOUNT_PROPERTIES_TEXT = {
  1: "城镇",
  2: "农村",
  3: "“农转非”被征地农民",
}
export const ACCOUNT_PROPERTIES_SELECTS = [
  {
    label: ACCOUNT_PROPERTIES_TEXT[1],
    value: 1,
  },
  {
    label: ACCOUNT_PROPERTIES_TEXT[2],
    value: 2,
  },
  {
    label: ACCOUNT_PROPERTIES_TEXT[3],
    value: 3,
  },
]

/** 社保类型 */
export const SUBSIDY = {
  /** 广州4050社保补贴 */
  GZ4050SBBT: 1,
  /** 适岗培训补贴 */
  SGPXBT: 2,
  /** 失业保险稳岗补贴 */
  SYBXWGBT: 3,
}
export const SUBSIDY_TEXT = {
  [SUBSIDY.GZ4050SBBT]: "广州4050社保补贴",
  [SUBSIDY.SGPXBT]: "适岗培训补贴",
  [SUBSIDY.SYBXWGBT]: "失业保险稳岗补贴",
}
export const SUBSIDY_SELECTS = [
  {
    label: SUBSIDY_TEXT[SUBSIDY.GZ4050SBBT],
    value: SUBSIDY.GZ4050SBBT,
  },
  {
    label: SUBSIDY_TEXT[SUBSIDY.SGPXBT],
    value: SUBSIDY.SGPXBT,
  },
  {
    label: SUBSIDY_TEXT[SUBSIDY.SYBXWGBT],
    value: SUBSIDY.SYBXWGBT,
  },
]

/** 职称服务 */
export const PROFESSIONAL = {
  /** 专业技术资格认定 */
  ZYJSZGRD: 1,
  /** 专业技术资格评审 */
  ZYJSZGPS: 2,
  /** 专业技术资格确认 */
  ZYJSZGQR: 3,
}
export const PROFESSIONAL_TEXT = {
  [PROFESSIONAL.ZYJSZGRD]: "专业技术资格认定",
  [PROFESSIONAL.ZYJSZGPS]: "专业技术资格评审",
  [PROFESSIONAL.ZYJSZGQR]: "专业技术资格确认",
}
export const PROFESSIONAL_SELECTS = [
  {
    label: PROFESSIONAL_TEXT[PROFESSIONAL.ZYJSZGRD],
    value: PROFESSIONAL.ZYJSZGRD,
  },
  {
    label: PROFESSIONAL_TEXT[PROFESSIONAL.ZYJSZGPS],
    value: SUBSIDY.ZYJSZGPS,
  },
  {
    label: PROFESSIONAL_TEXT[PROFESSIONAL.ZYJSZGQR],
    value: PROFESSIONAL.ZYJSZGQR,
  },
]

/** 渠道 */
export const CHANNEL = {
  /** 微信 */
  WX: 1,
}
export const CHANNEL_TEXT = {
  [CHANNEL.WX]: "微信",
}
export const CHANNEL_SELECTS = [
  {
    label: CHANNEL_TEXT[CHANNEL.WX],
    value: CHANNEL.WX,
  },
]

/** 订单状态 */
export const ORDER_STATUS = {
  /** 审核中 */
  CHECKING: 1,
  /** 待办理 */
  WAIT_HANDLE: 2,
  /** 审核失败 */
  CHECK_FAIL: 3,
  /** 办理成功 */
  SUCCESS: 4,
  /** 办理失败 */
  FAIL: 5,
  /** 已取消 */
  CANCELED: 6,
  /** 待缴费 */
  WAIT_PAY: 7,
  /** 已支付 */
  PAID: 8,
  /** 已退款[前端自定义状态] */
  REFUNDED: 1001,
}
export const ORDER_STATUS_TEXT = {
  [ORDER_STATUS.CHECKING]: "审核中",
  [ORDER_STATUS.WAIT_HANDLE]: "待办理",
  [ORDER_STATUS.CHECK_FAIL]: "审核失败",
  [ORDER_STATUS.SUCCESS]: "办理成功",
  [ORDER_STATUS.FAIL]: "办理失败",
  [ORDER_STATUS.CANCELED]: "已取消",
  [ORDER_STATUS.WAIT_PAY]: "待缴费",
  [ORDER_STATUS.PAID]: "已支付",
  [ORDER_STATUS.REFUNDED]: "已退款",
}
/** 订单类型 */
export const ORDER_TYPE = {
  /** 补贴订单 */
  SUBSIDY: 1,
  /** 专业技术资格 */
  PROFESSIONAL: 2,
}

/** 操作 */
export const OPERATE = {
  /** 查看 */
  CHECK: "check",
  /** 通过 */
  PASS: "pass",
  /** 不通过 */
  NO_PASS: "no_pass",
  /** 取消订单 */
  CANCEL: "cancel",
  /** 办理成功 */
  SUCCESS: "success",
  /** 办理失败 */
  FAIL: "fail",
  /** 已缴费 */
  PAID: "paid",
  /** 退款 */
  REFUND: "refund",
  /** 已退款 */
  REFUNDED: "refunded",
  /** 发证 */
  CERT: "cert",
  /** 已发证 */
  HAVE_CERTED: "have_certed",
}
export const OPERATE_TEXT = {
  [OPERATE.CHECK]: "查看",
  [OPERATE.PASS]: "通过",
  [OPERATE.NO_PASS]: "不通过",
  [OPERATE.CANCEL]: "取消订单",
  [OPERATE.SUCCESS]: "办理成功",
  [OPERATE.FAIL]: "办理失败",
  [OPERATE.PAID]: "已缴费",
  [OPERATE.REFUND]: "退款",
  [OPERATE.REFUNDED]: "已退款",
  [OPERATE.CERT]: "发证",
  [OPERATE.HAVE_CERTED]: "已发证",
}

/** 职称服务-申报条件-等级 */
export const CONDITION_LEVEL = {
  /** 员级 */
  LEVEL_1: 1001,
  /** 助理级 */
  LEVEL_2: 1002,
  /** 中级 */
  LEVEL_3: 1003,
  /** 副高级 */
  LEVEL_4: 1004,
  /** 正高级 */
  LEVEL_5: 1005,
  /** 助管 */
  LEVEL_6: 1006,
  /** 馆员 */
  LEVEL_7: 1007,
}
export const CONDITION_LEVEL_TEXT = {
  [CONDITION_LEVEL.LEVEL_1]: "员级",
  [CONDITION_LEVEL.LEVEL_2]: "助理级",
  [CONDITION_LEVEL.LEVEL_3]: "中级",
  [CONDITION_LEVEL.LEVEL_4]: "副高级",
  [CONDITION_LEVEL.LEVEL_5]: "正高级",
  [CONDITION_LEVEL.LEVEL_6]: "助管",
  [CONDITION_LEVEL.LEVEL_7]: "馆员",
}

/** 学历 */
export const EDUCATION = {
  /** 无 */
  EMPTY: 1000,
  /** 博士研究生 */
  DOCTOR: 1001,
  /** 硕士研究生 */
  MASTER: 1002,
  /** 本科 */
  UNDERGRADUATE: 1003,
  /** 大专 */
  JUNIOR_COLLEGE: 1004,
  /** 中专 */
  SECONDARY_SPECIALIZED: 1005,
  /** 中职 */
  SECONDARY_VOCATIONA: 1006,
  /** 技校 */
  TECHNICAL: 1007,
  /** 高中 */
  HIGH_SCHOOL: 1008,
  /** 初中 */
  MIDDLE_SCHOOL: 1009,
  /** 小学 */
  PRIMARY_SCHOOL: 1010,
}
export const EDUCATION_TEXT = {
  [EDUCATION.EMPTY]: "无",
  [EDUCATION.DOCTOR]: "博士研究生",
  [EDUCATION.MASTER]: "硕士研究生",
  [EDUCATION.UNDERGRADUATE]: "本科",
  [EDUCATION.JUNIOR_COLLEGE]: "大专",
  [EDUCATION.SECONDARY_SPECIALIZED]: "中专",
  [EDUCATION.SECONDARY_VOCATIONA]: "中职",
  [EDUCATION.TECHNICAL]: "技校",
  [EDUCATION.HIGH_SCHOOL]: "高中",
  [EDUCATION.MIDDLE_SCHOOL]: "初中",
  [EDUCATION.PRIMARY_SCHOOL]: "小学",
}
export const EDUCATION_SELECTS = [
  {
    label: EDUCATION_TEXT[EDUCATION.EMPTY],
    value: EDUCATION.EMPTY,
  },
  {
    label: EDUCATION_TEXT[EDUCATION.DOCTOR],
    value: EDUCATION.DOCTOR,
  },
  {
    label: EDUCATION_TEXT[EDUCATION.MASTER],
    value: EDUCATION.MASTER,
  },
  {
    label: EDUCATION_TEXT[EDUCATION.UNDERGRADUATE],
    value: EDUCATION.UNDERGRADUATE,
  },
  {
    label: EDUCATION_TEXT[EDUCATION.JUNIOR_COLLEGE],
    value: EDUCATION.JUNIOR_COLLEGE,
  },
  {
    label: EDUCATION_TEXT[EDUCATION.SECONDARY_SPECIALIZED],
    value: EDUCATION.SECONDARY_SPECIALIZED,
  },
  {
    label: EDUCATION_TEXT[EDUCATION.SECONDARY_VOCATIONA],
    value: EDUCATION.SECONDARY_VOCATIONA,
  },
  {
    label: EDUCATION_TEXT[EDUCATION.TECHNICAL],
    value: EDUCATION.TECHNICAL,
  },
  // {
  //   label: EDUCATION_TEXT[EDUCATION.HIGH_SCHOOL],
  //   value: EDUCATION.HIGH_SCHOOL,
  // },
  // {
  //   label: EDUCATION_TEXT[EDUCATION.MIDDLE_SCHOOL],
  //   value: EDUCATION.MIDDLE_SCHOOL,
  // },
  // {
  //   label: EDUCATION_TEXT[EDUCATION.PRIMARY_SCHOOL],
  //   value: EDUCATION.PRIMARY_SCHOOL,
  // },
]

/** 学位 */
export const DEGREE = {
  /** 无 */
  EMPTY: 1000,
  /** 博士学位 */
  DOCTOR: 1001,
  /** 硕士学位 */
  MASTER: 1002,
  /** 双学士学位 */
  DOUBLE_BACHELOR: 1003,
  /** 学士学位 */
  BACHELOR: 1004,
}
export const DEGREE_TEXT = {
  [DEGREE.EMPTY]: "无",
  [DEGREE.DOCTOR]: "博士学位",
  [DEGREE.MASTER]: "硕士学位",
  [DEGREE.DOUBLE_BACHELOR]: "双学士学位",
  [DEGREE.BACHELOR]: "学士学位",
}
export const DEGREE_SELECTS = [
  {
    label: DEGREE_TEXT[DEGREE.EMPTY],
    value: DEGREE.EMPTY,
  },
  {
    label: DEGREE_TEXT[DEGREE.DOCTOR],
    value: DEGREE.DOCTOR,
  },
  {
    label: DEGREE_TEXT[DEGREE.MASTER],
    value: DEGREE.MASTER,
  },
  {
    label: DEGREE_TEXT[DEGREE.DOUBLE_BACHELOR],
    value: DEGREE.DOUBLE_BACHELOR,
  },
  {
    label: DEGREE_TEXT[DEGREE.BACHELOR],
    value: DEGREE.BACHELOR,
  },
]

/** 查找枚举的key */
export const findEnumKey = (enumName, value) => {
  const compare = (a, b) => a === b
  return Object.keys(enumName).find((k) => compare(enumName[k], value))
}

/** 模板图片 */
export const TEMPLATE_IMAGES = {
  /** 企业营业执照副本照片 */
  business_license: require("../front/src/assets/image/template/business_license.jpg"),
  /** 社保明细 */
  social_security_details: require("../front/src/assets/image/template/social_security_details.jpg"),
  /** 毕业证 */
  diploma: require("../front/src/assets/image/template/diploma.jpg"),
  /** 专业技术资格证书（电子证） */
  title_certificate: require("../front/src/assets/image/template/title_certificate.jpg"),
  /** 资格证 */
  qualification_certificate: require("../front/src/assets/image/template/qualification_certificate.jpg"),
  qualification_certificate2: require("../front/src/assets/image/template/qualification_certificate2.jpg"),
  /** 评审表 */
  evaluation_review: require("../front/src/assets/image/template/evaluation_review.jpg"),
  /** 评审表2 */
  evaluation_review2: require("../front/src/assets/image/template/evaluation_review2.jpg"),
  /** 认定表 */
  evaluation_identify: require("../front/src/assets/image/template/evaluation_identify.jpg"),
  /** 认定表2 */
  evaluation_identify2: require("../front/src/assets/image/template/evaluation_identify2.jpg"),
}

/** 付款状态 */
export const PAID_STATUS = {
  /** 未付款 */
  UNPAID: 1,
  /** 已支付 */
  PAID: 2,
  /** 已退款 */
  REFUNDED: 3,
}
export const PAID_STATUS_TEXT = {
  [PAID_STATUS.UNPAID]: "未付款",
  [PAID_STATUS.PAID]: "已支付",
  [PAID_STATUS.REFUNDED]: "已退款",
}
export const PAID_STATUS_SELECTS = [
  {
    label: PAID_STATUS_TEXT[PAID_STATUS.UNPAID],
    value: PAID_STATUS.UNPAID,
  },
  {
    label: PAID_STATUS_TEXT[PAID_STATUS.PAID],
    value: PAID_STATUS.PAID,
  },
  {
    label: PAID_STATUS_TEXT[PAID_STATUS.REFUNDED],
    value: PAID_STATUS.REFUNDED,
  },
]

/** 支付方式 */
export const PAYMENT = {
  /** 无 */
  EMPTY: 1,
}
export const PAYMENT_TEXT = {
  [PAYMENT.EMPTY]: "无",
}
export const PAYMENT_SELECTS = [
  {
    label: PAYMENT_TEXT[PAYMENT.EMPTY],
    value: PAYMENT.EMPTY,
  },
]

/** 评审系列 */
export const SERIES = {
  /** 工程系列 */
  PROJECT: 1001,
  /** 档案系列 */
  FILE: 1002,
  /** 其他系列 */
  OTHERS: 1003,
}
export const SERIES_TEXT = {
  [SERIES.PROJECT]: "工程系列",
  [SERIES.FILE]: "档案系列",
  [SERIES.OTHERS]: "其他系列",
}
export const SERIES_SELECTS = [
  {
    label: SERIES_TEXT[SERIES.PROJECT],
    value: SERIES.PROJECT,
  },
  {
    label: SERIES_TEXT[SERIES.FILE],
    value: SERIES.FILE,
  },
  {
    label: SERIES_TEXT[SERIES.OTHERS],
    value: SERIES.OTHERS,
  },
]

/** 逻辑控制 */
export const LOGIC = {
  YES: 1,
  NO: 2,
}
export const LOGIC_TEXT = {
  [LOGIC.YES]: "是",
  [LOGIC.NO]: "否",
}
export const LOGIC_SELECTS = [
  {
    label: LOGIC_TEXT[LOGIC.YES],
    value: LOGIC.YES,
  },
  {
    label: LOGIC_TEXT[LOGIC.NO],
    value: LOGIC.NO,
  },
]

/** 文章数文案 */
export const ARTICLE_NUM_TEXT = {
  0: "0篇",
  1: "1篇",
  2: "2篇",
  3: "3篇",
  4: "4篇及以上",
}
export const ARTICLE_NUM_SELECTS = [
  {
    label: ARTICLE_NUM_TEXT[0],
    value: 0,
  },
  {
    label: ARTICLE_NUM_TEXT[1],
    value: 1,
  },
  {
    label: ARTICLE_NUM_TEXT[2],
    value: 2,
  },
  {
    label: ARTICLE_NUM_TEXT[3],
    value: 3,
  },
  {
    label: ARTICLE_NUM_TEXT[4],
    value: 4,
  },
]

/** 照片类型 */
export const PHOTO_TYPE = {
  /** 认定表 */
  IDENTIFY: 1001,
  /** 评审表 */
  REVIEW: 1002,
}
export const PHOTO_TYPE_TEXT = {
  [PHOTO_TYPE.IDENTIFY]: "认定表",
  [PHOTO_TYPE.REVIEW]: "评审表",
}
export const PHOTO_TYPE_DATA = [
  {
    label: PHOTO_TYPE_TEXT[PHOTO_TYPE.IDENTIFY],
    value: PHOTO_TYPE.IDENTIFY,
  },
  {
    label: PHOTO_TYPE_TEXT[PHOTO_TYPE.REVIEW],
    value: PHOTO_TYPE.REVIEW,
  },
]
